import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiRequests } from '../../shared/api/apiRequests.js';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const PromocodesPage = () => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const location = useLocation();

  const handleDelete = (id) => {
    if (!id) return;
    apiRequests.promocodes.delete(id)
      .then(() => {
        toast.success('Промокод успешно удален');
        getData();
      })
      .catch((error) => {
        console.error('Ошибка при удалении промокода:', error);
        toast.error('Произошла ошибка при удалении промокода');
      });
  };

  const getData = (count = 5, offset = 0) => {
    apiRequests.promocodes.get(count, offset)
      .then((res) => {
        if (res && res.items) {
          const normalizedItems = res.items.map(item => ({
            ...item,
            priceFrom: item.priceFrom || { costs: [] },
            priceTo: item.priceTo || { costs: [] },
            percent: item.percent !== undefined ? item.percent : 0,
            discount: item.discount || { costs: [] }
          }));

          setData({
            ...res,
            items: normalizedItems
          });
        } else {
          setData({ items: [], totalCount: 0 });
        }
      })
      .catch((error) => {
        console.error('Ошибка при загрузке промокодов:', error);
        toast.error('Произошла ошибка при загрузке промокодов');
        setData({ items: [], totalCount: 0 });
      });
  };

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.promocodes.get(5, 0, searchValue)
        .then((res) => {
          if (res && res.items) {
            const normalizedItems = res.items.map(item => ({
              ...item,
              priceFrom: item.priceFrom || { costs: [] },
              priceTo: item.priceTo || { costs: [] },
              percent: item.percent !== undefined ? item.percent : 0,
              discount: item.discount || { costs: [] }
            }));

            setData({
              ...res,
              items: normalizedItems
            });
          } else {
            setData({ items: [], totalCount: 0 });
          }
        })
        .catch((error) => {
          console.error('Ошибка при поиске промокодов:', error);
          toast.error('Произошла ошибка при поиске промокодов');
          setData({ items: [], totalCount: 0 });
        });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск промокодов..."
        createLink={`${location.pathname}/create`}
      />

      <div className="mb-3">
        {data.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          data.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.code}
              fields={[
                { label: 'Скидка', value: item.discriminator === 'PercentPromocode' ? `${item.percent || 0}%` : 'Фиксированная' },
                { label: 'Истекает', value: item.endDate ? dateToString(item.endDate) : 'Не указано' },
                { label: 'Создано', value: item.createdAt ? dateToString(item.createdAt) : 'Не указано' },
              ]}
              editLink={`${location.pathname}/${item.id}`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination
        count={data.totalCount || 0}
        itemsPerPage={5}
        onChange={(page) => {
          try {
            const offset = Math.max(0, 5 * page);
            console.log(`Загрузка страницы ${page+1}, оффсет: ${offset}`);
            getData(5, offset);
          } catch (error) {
            console.error('Ошибка при переключении страницы:', error);
            toast.error('Произошла ошибка при переключении страницы');
          }
        }}
      />
    </>
  );
};

export default PromocodesPage;
